/*
 *
 * File Name : common.js [use jquery]
 *
 */


// ---------------------------------------------------------------------
// check browser 
// ex) if(util.isTablet){ ... } // true or false
// ---------------------------------------------------------------------
var util = (function(u){
  return {
    isTablet:(u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1) 
      || u.indexOf("ipad") != -1
      || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1),
      
    isAndroid:(u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
      || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1),
    
    isIOS:(u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
      || u.indexOf("iphone") != -1
      || u.indexOf("ipod") != -1,
    
    isWebview:(/iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase()) && /twitter|fbav|line/.test(navigator.userAgent.toLowerCase()))
  }
})(window.navigator.userAgent.toLowerCase());


/*********************************************************************************************/
// scroll
/*********************************************************************************************/
function smoothScroll(){
  var span   = 1000;
  var effect = 'easeOutExpo';

  $("a.scroll---stop").on('click', function(){
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      $(this).blur();
      var t = navigator.appName.match(/Opera/) ? "html" : "html,body";
      $(t).queue([]).stop();
      var $targetElement = $(this.hash);
      var scrollTo = $targetElement.offset().top;
      if (window.scrollMaxY) {
        var maxScroll = window.scrollMaxY;
      } else {
        var maxScroll = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      }
      if (scrollTo > maxScroll){
        scrollTo = maxScroll;
      }
      $(t).animate({ scrollTop: scrollTo }, span, effect);
      return false;
    }
  });
}

$(function(){
$('a[href^="#"]').click(function(){
var speed = 1000;
var href= $(this).attr("href");
var target = $(href == "#" || href == "" ? 'html' : href);
var position = target.offset().top;
$("html, body").animate({scrollTop:position}, speed, "swing");
return false;
});
});

/*********************************************************************************************/
// scroll add class
/*********************************************************************************************/
(function($){
  $.fn.scrollClass = function(config){
    var defaults = {};
    var config = $.extend(defaults, config);
    var target = this;

    function addAction(){
      var length = target.length;
      for(var i=0; i<length; i++){
        if(target.eq(i).hasClass('action')) continue;

        var in_position = target.eq(i).offset().top + 100;
        var window_bottom_position = $(window).scrollTop() + $(window).height();
        if(in_position < window_bottom_position){
          target.eq(i).addClass('action');
        }
      }
    }
    addAction();

    $(window).on('scroll', $.throttle(250, function(){
      addAction();
    }));
    return target;
  };
} )(jQuery);

/*********************************************************************************************/
// side nav color
/*********************************************************************************************/
function changeColor(){
  var _window = $(window);
  var _pagetop = $('#btnPagetop');
  var _sns = $('#sns');
  var scrollTop = $(window).scrollTop();
  
  var change = function(){
    $('.chng_box').each(function(){
      var _this = $(this);
      var color = _this.attr('data-color');
      
      // sns
      if((scrollTop+_window.height()/2) > _this.offset().top){
        if(color == 'wh'){
          _sns.removeClass('bk').addClass('wh');
        }
        else {
          _sns.removeClass('wh').addClass('bk');
        }
      }
      
      // pagetop
      if((scrollTop+_window.height()) >= _this.offset().top){
        if(color == 'wh'){
          _pagetop.removeClass('bk').addClass('wh');
        }
        else {
          _pagetop.removeClass('wh').addClass('bk');
        }
      }
    });
  };
  
  change();
  
  _window.on('scroll', function(){
    scrollTop = $(window).scrollTop();
    
    change();
  });
}

// sp judge
var tbView = 'width=1024px';
var spView = 'width=device-width,initial-scale=1';
if (util.isTablet){$('body').addClass('tb');}

if (util.isAndroid || util.isIOS){
  $('head').prepend('<meta name="viewport" content="' + spView + '" id="viewport">');
  $('body').addClass('sp');
  
  $(document).on('click', '#btnMenu a', function(){
    $(this).toggleClass('active');
    $('.gnav').toggleClass('active');
  });
  
  var slideW = $(window).width();
  var slideViewNum = 1;
}
else {
  $('head').prepend('<meta name="viewport" content="' + tbView + '" id="viewport">');
  $('body').addClass('pc');
  var slideW = 1000;
  var slideViewNum = 3;
}


$(window).load(function(){
  smoothScroll();
  changeColor();
  $('.target').delay(500).scrollClass();
});
